import React, { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

import * as api from "../../services";
import MutationMessage from "../../Components/MutationMessage";
import RenameDialog from "../../Components/RenameDialog";
import { useTranslation } from "react-i18next";
import BoardsContext from "../boardsContext";
import useSaveSettings from "../../User/useSaveSettings";
import AppContext from "../../appContext";

function ExportDialog({
  exportDialog,
  setExportDialog,
  board: publicBoard,
  setImportedBoard,
}) {
  const { t } = useTranslation();
  const {
    app: {
      project: { id: projectId },
      sessionId
    },
  } = useContext(AppContext);
  const { moodboards } = useContext(BoardsContext);
  const queryClient = useQueryClient();
  const saveSettings = useSaveSettings();
  const saveMutation = useMutation((data) => api.postPublicMoodboard(data), {
    onSuccess: (data, { name }) => {
      if (data.data?.status > 0 && data?.data.id) {
        setImportedBoard({ id: data.data.id, name: name });
        saveSettings.mutate({ moodBoardId: data.data.id });
        queryClient.invalidateQueries("publicMoodboards"); // refresh the list of public moodboards
        //refetchMoodboards(); // refresh the list of public moodboards
        setExportDialog((prev) => ({ ...prev, open: false })); // close the dialog
      }
    },
  });

  const exportModes = {
    export: {
      id: -1,
      input: "",
      dialogTitle: "Export graphs to library",
      dialogContentText: "Enter a name for your graphs:",
      dialogActionConfirm: "Export",
    },
    save: {
      id: publicBoard?.id,
      input: publicBoard?.name,
      dialogTitle: "Save graphs to library",
      dialogContentText: "Enter a name for your graphs:",
      dialogActionConfirm: "Save",
    },
  };
  const exportMode = exportModes?.[exportDialog.mode] ?? exportModes.export;

  const renameFunction = (name) => {
    saveMutation.mutate({
      id: exportMode.id,
      name,
      moodBoardJSON: JSON.stringify(moodboards),
      projectId,
      sessionId
    });
  };

  return (
    <div>
      <MutationMessage
        mutation={saveMutation}
        text={{ loading: "Saving", success: "Saved" }}
      />
      <RenameDialog
        open={exportDialog.open}
        setOpen={setExportDialog}
        renameFunction={renameFunction}
        input={exportMode.input}
        dialogTitle={exportMode.dialogTitle}
        dialogContentText={exportMode.dialogContentText}
        dialogActionCancel={t("common.actions.cancel")}
        dialogActionConfirm={exportMode.dialogActionConfirm}
      />
    </div>
  );
}

export default ExportDialog;
